import ResultTable from "../Table/ResultTable";
import ResultHeader from "../Table/ResultHeader";
import ResultRow from "../Table/ResultRow";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import ResultBody from "../Table/ResultBody";
import ResultBodyCell from "../Table/ResultBodyCell";
import HecRasHelper from "../../Helpers/HecRasHelper";
import {Typography} from "antd";
import {useEffect} from "react";

export default function HecRasOutputTable({profileData, mapProfiles, rivers}) {
    return (
        <div style={{overflowY: 'auto', height: 500}}>
            <ResultTable style={{width: HecRasHelper.getWidth(188)}}>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start', position: 'sticky', top: -1}}>
                            Cross Section
                        </ResultHeaderCell>
                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(16), textAlign: 'start', position: 'sticky', top: -1}}>
                            Profile
                        </ResultHeaderCell>
                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(16), textAlign: 'start', position: 'sticky', top: -1}}>
                            River
                        </ResultHeaderCell>
                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start', position: 'sticky', top: -1}}>
                            Reach
                        </ResultHeaderCell>
                        {
                            ['StaWSLft', 'StaWSRgt', 'WSElev', 'ProfDeltaWS', 'CritWS', 'Headloss', 'ConvRatio', 'VelHead', 'MannWtdLeft', 'MannWtdChn', 'MannWtdRight'].map(title => {
                                return (
                                    <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'end', position: 'sticky', top: -1}}>
                                        {title}
                                    </ResultHeaderCell>
                                )
                            })
                        }
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        profileData?.profiles?.map((profile) => {
                            return (
                                <ResultRow>
                                    <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start'}}>
                                        {profile?.data?.CrossSection}
                                    </ResultHeaderCell>
                                    <ResultBodyCell style={{width: HecRasHelper.getWidth(16), textAlign: 'start'}}>
                                        {profile?.data?.Profile}&emsp;({mapProfiles?.find(x => x?.select === profile?.data?.Profile)?.targetName})
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{width: HecRasHelper.getWidth(16), textAlign: 'start'}}>
                                        <Typography.Text ellipsis={true} style={{width: HecRasHelper.getWidth(16)}}>
                                            {profile?.data?.River || (rivers?.length === 1 && rivers[0].river)}
                                        </Typography.Text>
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start'}}>
                                        {profile?.data?.Reach}
                                    </ResultBodyCell>
                                    {
                                        ['StaWSLft', 'StaWSRgt', 'WSElev', 'ProfDeltaWS', 'CritWS', 'Headloss', 'ConvRatio', 'VelHead'].map(title => {
                                            return (
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(12), textAlign: 'end'}}>
                                                    {profile?.data[title]?.toFixed(2)}
                                                </ResultBodyCell>
                                            )
                                        })
                                    }
                                    {
                                        ['MannWtdLeft', 'MannWtdChn', 'MannWtdRight'].map(title => {
                                            return (
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(12), textAlign: 'end'}}>
                                                    {(profile?.data[title] && profile?.data[title]?.toFixed(3)) || (profile?.data[title]?.toString() !== '0' && '-')}
                                                </ResultBodyCell>
                                            )
                                        })
                                    }
                                </ResultRow>
                            )
                        })
                    }
                </ResultBody>
            </ResultTable>
        </div>
    )
}